(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldTimeslotpicker', fbFieldTimeslotpickerDirective);

    function fbFieldTimeslotpickerDirective($timeout) {
        return {
            restrict: 'EA',
            scope: {
                element:'=',
                model: '='
            },
            templateUrl: 'common/libraries/formBuilder/fields/fieldTimeslotpicker',
            controller: fbFieldTimeslotpickerDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function(scope) {
            }
        };
    }

    function fbFieldTimeslotpickerDirectiveCtrl(lodash, FormBuilderService, $scope) {
        var vm = this;
        this.$onInit = function() {
            var formIdentifier = $scope.$parent.vm.formIdentifier;
            var timeSlotPickerOptions = lodash.get($scope.$parent.$parent.$parent.$parent.$parent.$parent.$parent.vm, 'panelState.scheduler_settings.time_slot_picker_options', {'step':15});
            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
            vm.options = angular.merge({},
                lodash.get(vm.element,'attr.options',{})
            );
            angular.merge(vm.element.options, timeSlotPickerOptions);
        };
    }
})();